import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import TextField from '@atlaskit/textfield';
import { N500 } from '@atlaskit/theme/colors';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import debounce from 'lodash/debounce';
import React, { useState } from 'react';
import AtlassianStandsWithUkraineModal from "../../../../../common/components/AtlassianStandsWithUkraineModal";
import TabHeader from "../../../../../common/components/Tabs/TabHeader";
import { usePartnerDetails } from "../../../../../common/hooks.js";
import { PAGINATION_LIMIT } from "../../../../constants/Preferences";
import { usePartnerApps } from "../hooks/hooks";
import NoAppsView from "../NoAppsView";
import { appSearchAnalyticsConfig, createAppButtonAnalyticsConfig } from "./PartnerApps.events";
import PartnerAppsTable from "./PartnerAppsTable";

const PartnerApps = ({
  partnerId,
  mpacBaseUrl
}) => {
  const showLoyaltyDiscountRow = true;
  const {
    partnerDetails
  } = usePartnerDetails(mpacBaseUrl, partnerId);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchQuery, setSearchQuery] = useState(null); // offset in which the paginated results should start from (for ex: 0, 10, 20)

  const {
    partnerApps,
    pending,
    error
  } = usePartnerApps(mpacBaseUrl, partnerId, (pageNumber - 1) * PAGINATION_LIMIT, searchQuery);
  const partnerPermissions = usePartnerPermissions();
  const fireAnalyticsEvent = useAnalyticsEvents();

  const handleSearch = searchText => {
    fireAnalyticsEvent(appSearchAnalyticsConfig({
      text: searchText,
      partnerId
    }));
    setPageNumber(1);
    setSearchQuery(searchText);
  };

  const processSearchChange = debounce(handleSearch, 300);

  const onCreateAppClick = () => {
    fireAnalyticsEvent(createAppButtonAnalyticsConfig({
      partnerId
    }));
    window.location.href = '/manage/apps/create';
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Apps",
    ctaText: partnerPermissions !== null && partnerPermissions !== void 0 && partnerPermissions.canManagePartnerDetails ? 'Create app' : '',
    onCTAClick: onCreateAppClick
  }), /*#__PURE__*/React.createElement(AtlassianStandsWithUkraineModal, null), partnerApps && partnerApps.count === 0 && partnerDetails && !searchQuery && !pending ? /*#__PURE__*/React.createElement(NoAppsView, {
    partnerDetails: partnerDetails,
    canManagePartnerDetails: partnerPermissions === null || partnerPermissions === void 0 ? void 0 : partnerPermissions.canManagePartnerDetails,
    onCreateAppClick: onCreateAppClick
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    placeholder: "Search for apps",
    width: "large",
    elemBeforeInput: /*#__PURE__*/React.createElement(EditorSearchIcon, {
      primaryColor: N500
    }),
    onChange: e => processSearchChange(e.target.value.trim())
  }), /*#__PURE__*/React.createElement(PartnerAppsTable, {
    partnerApps: partnerApps,
    showLoyaltyDiscountRow: showLoyaltyDiscountRow,
    pending: pending,
    error: !!error,
    pageNumber: pageNumber,
    setPageNumber: setPageNumber,
    partnerId: partnerId
  })));
};

export default PartnerApps;